module.exports = __webpack_public_path__ + "img/circle1.707d3b70.png";